<template>
  <div class="light-angle-content" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>添加</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="设备名称"> </el-table-column>
        <el-table-column prop="number" label="设备编号"> </el-table-column>
        <el-table-column prop="lamp_name" label="所属路灯"> </el-table-column>
        <el-table-column label="角度校正(相对/绝对)" prop="type">
          <template slot-scope="scope">
            <span class="switch_text" v-if="scope.row.armed">绝对</span>
            <span class="switch_text" v-else style="color:#2c8cf2">绝对</span>
            <el-switch
              v-model="scope.row.angle_type"
              :active-value="1"
              :inactive-value="0"
              active-color="#3ba631"
              inactive-color="#B9B9B9"
              @change="changeAngle(scope.row.id,$event,1)"
            />
            <span class="switch_text" v-if="scope.row.armed" style="color:#3ba631">相对</span>
            <span class="switch_text" v-else>相对</span>
          </template>
        </el-table-column>
        <el-table-column prop="x_angle" label="倾斜角(X°)"> </el-table-column>
        <el-table-column prop="y_angle" label="倾斜角(Y°)"> </el-table-column>

        <el-table-column prop="type" label="通讯模式">
          <template slot-scope="scope">
            {{typeArr[scope.row.type]}}
          </template>
        </el-table-column>

        <el-table-column label="设防" prop="type">
          <template slot-scope="scope">
            <span class="switch_text" v-if="scope.row.armed">未设防</span>
            <span class="switch_text" v-else  style="color:rgba(241, 12, 4, 0.856)">未设防</span>
            <el-switch
              v-model="scope.row.armed"
              :active-value="1"
              :inactive-value="0"
              active-color="#3ba631"
              inactive-color="#B9B9B9"
              @change="changeAngle(scope.row.id,$event,2)"
            />
            
            <span class="switch_text" v-if="scope.row.armed" style="color:#3ba631">设防中</span>
            <span class="switch_text" v-else>设防中</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="edit" label="编辑" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加' : '修改'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item label="设备名称" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item label="设备编号" prop="number">
            <el-input v-model="editOne.number"></el-input>
          </el-form-item>
          <el-form-item label="设备类型" prop="type" v-if="editType === 'create'">
            <el-radio-group v-model="editOne.type">
              <el-radio :label="0">网关模式</el-radio>
              <el-radio :label="1">接口模式</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="选择路灯">
            <el-select
              clearable
              filterable 
              placeholder="请选择所属路灯"
              v-model="editOne.lamp_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in lampList"
                :key="t.lamp_id"
                :label="t.name"
                :value="t.lamp_id"
              ></el-option>
            </el-select>
          </el-form-item>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import lightListApi from "@/api/light/lightList";
import angleApi from "@/api/light/angle";
import store from '@/store'
export default {
  data() {
    const vm = this;
    return {
      loading: false,
      dialogVisible: false,
      typeArr: ['网关模式','接口模式'],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      editType: -1,
      lampList: [],
      editOne: {},
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      angleApi.angleList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.getLampList()
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    getLampList() { // 获取路灯列表
      lightListApi.lightList({
        page: 1,
        pageSize: 500,
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.lampList = resData.list;
        }
      });
    },
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: '',
          number: '',
          type: '',
          lamp_id: '',
        }
        this.editType = "create"
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          number: index.number,
          type: index.type,
          lamp_id:index.lamp_id
        }
        this.editType = "update"
      }
      this.dialogVisible = true
    },

    updateItem() {
      angleApi.angleEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      angleApi.angleAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          angleApi.angleDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeAngle(id, value,type) {
      let datas={}
      if(type==1){ //设置倾斜角
        datas={ 
          angle: value,
          armed: ''
        }
      }else{ //设防
        datas={ 
          angle: '',
          armed: value
        }
      }
      angleApi.setAngle(id,datas).then((res) => {
        console.log('res',res)
        if (res.data.code === 1000) {
          this.$message.success("设置成功");
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  }
};
</script>
<style lang='less'>
.light-angle-content {
  width: 100%;
  .switch_text{
    margin: 0 5px;
  }
  .form-info{
    .el-form-item__label{
      width:90px;
    }
  }
}

</style>